<template>
  <div>
    <v-row class="pl-3">
      <h2>
        <span class="blue-grey--text text--darken-1">Affiliate Name: </span
        >{{ registration.name }}
      </h2>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <h3>
          <span class="blue-grey--text text--darken-1"> Events and activities: </span
          ><p>{{ registration.eventsAndActivities }}</p>
        </h3>
        <h3 v-if="registration.clubsite">
          <span class="blue-grey--text text--darken-1"> Affiliate Website: </span
          ><a :href="registration.clubsite" target="_blank">{{ registration.clubsite }}</a>
        </h3>
      </v-col>
      <v-divider vertical light class="d-none d-sm-flex"></v-divider>
      <v-col cols="12" sm="6">
        <h3 class="blue-grey--text text--darken-1">
          Affiliate Officers & Members:
        </h3>
        <span v-for="(person, idx) in registration.affMembers" :key="idx">
          <b>{{person.isPrimary ? "Primary" : ""}} {{ person.position }}</b> - {{ person.firstName }} {{ person.lastName }}
          <br />
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  name: "RenewAffiliateRequest",
  props: {
    registration: { type: Object },
  },
});
</script>